import { createFileRoute } from '@tanstack/react-router';
import { CasinoCategoryPage } from '@/ui/casino';

export const Route = createFileRoute('/casino/$category/')({
  validateSearch: (search: Record<string, unknown>): { q?: string } => {
    const q = typeof search.q === 'string' ? search.q : undefined;
    return q ? { q } : {};
  },
  component: CasinoCategoryRoute,
});

function CasinoCategoryRoute() {
  const { category } = Route.useParams();
  const { q } = Route.useSearch();
  return <CasinoCategoryPage category={category} initialSearch={q ?? ''} />;
}
